import React from 'react';
import classNames from 'classnames';

export default function CardContent(props: { children?: React.ReactNode; ignoreContentSpacing?: boolean; className?: string }) {
  return (
    <div className={classNames('card-content', 'px-4 sm:px-6', props.ignoreContentSpacing ? 'py-0 sm:py-5' : 'py-5', props.className)}>
      {props.children}
    </div>
  );
}
